/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_WorksInputs */

const en_nav_works = /** @type {(inputs: Nav_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Works`)
};

const ar_nav_works = /** @type {(inputs: Nav_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أعمالي`)
};

const bn_nav_works = /** @type {(inputs: Nav_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কাজ`)
};

const de_nav_works = /** @type {(inputs: Nav_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekte`)
};

const es_nav_works = /** @type {(inputs: Nav_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyectos`)
};

const fr_nav_works = /** @type {(inputs: Nav_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projets`)
};

const pt_nav_works = /** @type {(inputs: Nav_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projetos`)
};

const zh_nav_works = /** @type {(inputs: Nav_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作品`)
};

const tr_nav_works = /** @type {(inputs: Nav_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeler`)
};

const ru_nav_works = /** @type {(inputs: Nav_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проекты`)
};

const pl_nav_works = /** @type {(inputs: Nav_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekty`)
};

/**
* | output |
* | --- |
* | "Works" |
*
* @param {Nav_WorksInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const nav_works = /** @type {((inputs?: Nav_WorksInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_WorksInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_nav_works(inputs)
	if (locale === "bn") return bn_nav_works(inputs)
	if (locale === "de") return de_nav_works(inputs)
	if (locale === "es") return es_nav_works(inputs)
	if (locale === "fr") return fr_nav_works(inputs)
	if (locale === "pt") return pt_nav_works(inputs)
	if (locale === "zh") return zh_nav_works(inputs)
	if (locale === "tr") return tr_nav_works(inputs)
	if (locale === "ru") return ru_nav_works(inputs)
	if (locale === "pl") return pl_nav_works(inputs)
	return en_nav_works(inputs)
});